import { render, staticRenderFns } from "./HoverableDate.vue?vue&type=template&id=3997f3bc"
import script from "./HoverableDate.vue?vue&type=script&lang=js"
export * from "./HoverableDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports